/* Global constants */

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const CLOSING_TIMES = {
    Monday: '21:00', Tuesday: '21:00', Wednesday: '21:00', Thursday: '21:00',
    Friday: '22:00', Saturday: '22:00', Sunday: '21:00'
};

// Driver night shifts. The closer takes one start and runs to close;
// the others take remaining starts and staggered ends.
const DRIVER_NIGHT_STARTS = ['16:00', '16:30', '17:00'];
const DRIVER_NIGHT_ENDS = {
    weekday: ['19:00', '20:00', '20:30'],
    weekend: ['20:00', '20:30', '21:00', '21:30']
};
const DRIVER_DAY_SHIFT = { start: '10:30', end: '16:00', fridayEnd: '19:00' };

const START_TIMES = {begin: 420, end: 1050}; // hours to minutes, 7am to 5;30pm
const END_TIMES = {begin: 720, end: 1350}; // noon to 10:30

// Minutes since midnight. Shifts starting before this count as day, after as night
const DAY_NIGHT_BOUNDARY = 16 * 60;

const GROUP_ORDER = ['Manager', 'Shift Leader', 'Over 18', 'Under 18', 'Under 16', 'Drivers'];

const POSITION_GROUPS = ['Over 18', 'Under 18', 'Under 16'];
const GLOBAL_EXP_GROUPS = ['Manager', 'Shift Leader', 'Drivers']; // differentiated experience between staff
const POSITIONS = ['Pies', 'Hoagies', 'Front', 'DR']; 

const REQUIRED_CLOSERS = 2;

// Non-manager, non-driver crew by projected daily revenue
// Managers, shift leaders and drivers are additive on top of these numbers
// Crew per day part, from that part's projected sales.
// Managers, shift leaders and drivers are additive on top of these numbers.
const SALES_PER_CREW = 340;
const MIN_CREW_PER_PART = 6;

const UNAVAILABLE = ['Not Available', 'Requested Off'];

module.exports = {
    DAYS, CLOSING_TIMES, START_TIMES, END_TIMES, GROUP_ORDER,
    REQUIRED_CLOSERS, SALES_PER_CREW, MIN_CREW_PER_PART, UNAVAILABLE,
    POSITION_GROUPS, GLOBAL_EXP_GROUPS, POSITIONS, DAY_NIGHT_BOUNDARY, DRIVER_NIGHT_STARTS, DRIVER_NIGHT_ENDS, DRIVER_DAY_SHIFT
};